export const BASE_COLUMNS: Array<any> = [
    {
        column: {
            id: 'numAssociatedProducts',
            Header: 'Associated products',
            accessor: (row: any) => row.numAssociatedProducts,
            dataType: 'integer',
            width: 180,
            minWidth: 180,
            canResize: true,
        },
        index: 1,
    },
];
